import { signAsync, utils as secpUtils, getSharedSecret } from '@noble/secp256k1';
import { keccak_256 } from '@noble/hashes/sha3';
import { randomBytes, bytesToHex } from '@noble/hashes/utils';
import { xchacha20poly1305 } from '@noble/ciphers/chacha';
import { bytesToUtf8, utf8ToBytes } from '@noble/ciphers/utils';
import { base64 } from '@scure/base';
export { getPublicKey } from '@noble/secp256k1';
export class API {
    endpoint;
    fetchFunction;
    constructor(endpoint, options) {
        this.endpoint = endpoint;
        this.fetchFunction = options?.fetch || fetch;
    }
    async call(action, options) {
        const headers = {
            'content-type': 'application/json'
        };
        const body = JSON.stringify(action);
        if (options) {
            if ('privateKey' in options) {
                const signature = await signAsync(keccak_256(body), options.privateKey); // Sync methods below
                headers.SIGNATURE = `${signature.toCompactHex()}:${signature.recovery}`;
            }
            else {
                headers.SIGNATURE =
                    'signature' in options ? options.signature : `FAKE:${options.publicKey}`;
            }
        }
        const resp = await this.fetchFunction(this.endpoint, {
            method: 'POST',
            body,
            headers
        });
        if (resp.status !== 200) {
            throw new Error(await resp.text());
        }
        if (resp) {
            return (await resp.json());
        }
        else {
            throw new Error(`no response`);
        }
    }
    async register(action, options) {
        return this.call({
            type: 'register',
            ...action
        }, options);
    }
    async sendMessage(action, options) {
        return this.call({
            type: 'sendMessage',
            ...action
        }, options);
    }
    async getConversations(action, options) {
        return this.call({
            type: 'getConversations',
            ...action
        }, options);
    }
    async getAcceptedConversations(action, options) {
        return this.call({
            type: 'getAcceptedConversations',
            ...action
        }, options);
    }
    async getUnacceptedConversations(action, options) {
        return this.call({
            type: 'getUnacceptedConversations',
            ...action
        }, options);
    }
    async acceptConversation(conversation, options) {
        return this.call({
            type: 'acceptConversation',
            ...conversation
        }, options);
    }
    async getMessages(chat, options) {
        return this.call({
            type: 'getMessages',
            ...chat
        }, options);
    }
    async getUser(action) {
        return this.call({
            type: 'getUser',
            ...action
        });
    }
    async getDomainUser(action) {
        return this.call({
            type: 'getDomainUser',
            ...action
        });
    }
    async clear() {
        return this.call({
            type: 'db:reset'
        });
    }
}
